import {Component, Input, ViewChild} from '@angular/core';
import {FileService}                 from '@src/app/shared/services/file.service';

@Component({
    standalone: false,
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class UploadComponent
{
    @Input()
    public controlName: string = 'file';

    @Input()
    public emptyFileMessage: string = 'No file uploaded yet.';

    @Input()
    public requiredFileType: string;

    @Input()
    public autoUpload: boolean = false;

    @Input()
    public allowMultiple: boolean = false;

    @Input()
    public disabled: boolean = false;

    @Input()
    public uploadUrl: string = null;

    @ViewChild('fileUpload')
    public fileUpload: any;

    public fileName: string = '';

    public constructor(
        public fileService: FileService,
    )
    {
    }

    public onFileSelected(event: any): void
    {
        for (let i = 0; i < event.target.files.length; i++) {
            this.fileService.files.push(event.target.files[i]);
        }

        // TODO: Make this support multiple files?
        this.fileName = this.fileService.files[0].name;

        if (this.fileService.files.length > 0) {
            if (this.autoUpload && this.uploadUrl) {
                this.fileService.upload(this.uploadUrl, this.controlName);
            }
        }
    }

    public clear(): void
    {
        this.fileUpload.value = null;
        this.fileName = null;
    }
}
